import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Header } from './components/Header';
import { HomePage } from './pages/HomePage';
import { ProjectPage } from './pages/ProjectPage';
import { AuthModal } from './components/AuthModal';
import { User } from './types';
import { api } from './api/client';

export const App: React.FC = () => {
  const [user, setUser] = useState<User | null>(null);
  const [showAuthModal, setShowAuthModal] = useState(false);

  useEffect(() => {
    // Check active session
    api.getMe().then(({ user }) => {
      if (user) setUser(user);
    });
  }, []);

  return (
    <BrowserRouter>
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Header
          user={user}
          onOpenAuth={() => setShowAuthModal(true)}
          onUserChange={setUser}
        />

        <main style={{ flex: 1 }}>
          <Routes>
            <Route
              path="/"
              element={<HomePage user={user} onOpenAuth={() => setShowAuthModal(true)} />}
            />
            <Route
              path="/:slug"
              element={<ProjectPage user={user} onOpenAuth={() => setShowAuthModal(true)} />}
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>

        {showAuthModal && (
          <AuthModal
            user={user}
            onClose={() => setShowAuthModal(false)}
            onSuccess={(u) => setUser(u)}
          />
        )}
      </div>
    </BrowserRouter>
  );
};

export default App;
